import React, { useEffect, useState } from "react";
import PaymentError from "../PaymentError";

export default function FakePaypalButton(props) {
  const {
    validate,
    onClick,
    payment,
    onAuthorize,
    onCancel,
    onError,
    processing,
    disabled,
    errorMessage
  } = props;

  const [internalDisabled, setInternalDisabled] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [data, setData] = useState(null);

  const actions = {
    disable: () => setInternalDisabled(true),
    enable: () => setInternalDisabled(false)
  };

  useEffect(() => validate(actions), []);

  const resolve = (paymentToken) => {
    setData({ paymentToken });
  };

  const reject = (error) => {
    setShowOverlay(false);
    onError({ message: error });
  };

  const buttonOnClick = async () => {
    onClick();
    if (!internalDisabled) {
      await payment(resolve, reject);
      setShowOverlay(true);
    }
  };

  const overlayButtonOnClick = () => {
    onAuthorize(data);
    setShowOverlay(false);
  };

  const cancelButtonOnClick = () => {
    setShowOverlay(false);
    onCancel();
  };

  return (
    <>
      <PaymentError errorMessage={errorMessage} testId="paypal-error" />
      <div id="lc-paypal-button-container">
        <button
          type="button"
          data-testid="fake-paypal-button"
          onClick={buttonOnClick}
        >
          Fake Paypal Button
        </button>
      </div>
      {processing && <div>Paypal Processing</div>}
      {disabled && <div>Paypal Disabled</div>}
      {internalDisabled && <div>Paypal Internal Disabled</div>}
      {showOverlay && (
        <div>
          Paypal Overlay
          <button
            type="button"
            data-testid="fake-paypal-overlay-button"
            onClick={overlayButtonOnClick}
          >
            Paypal Overlay Button
          </button>
          <button
            type="button"
            data-testid="fake-paypal-cancel-button"
            onClick={cancelButtonOnClick}
          >
            Paypal Overlay Cancel Button
          </button>
        </div>
      )}
    </>
  );
}
